import { DatePicker } from "antd";
import { FC } from "react";
import { Control, Controller } from "react-hook-form";
import styles from "./PeriodRangePicker.module.scss";
import clsx from "clsx";
import locale from "antd/es/date-picker/locale/ru_RU";
import { FormValues } from "../../types";
import { RangePickerProps } from "antd/es/date-picker";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;

interface PeriodRangePicker {
  control: Control<FormValues>;
  disabled?: boolean;
}

export const PeriodRangePicker: FC<PeriodRangePicker> = ({
  control,
  disabled,
}) => {
  const disabledDate: RangePickerProps["disabledDate"] = (current) => {
    return current ? current < dayjs().startOf("day") : false;
  };
  return (
    <div className={clsx(styles.withoutBefore)}>
      <span className={styles.selectTitle}>Период</span>
      <Controller
        name="period"
        control={control}
        rules={{ required: "Выберите период" }}
        render={({ field, fieldState }) => (
          <>
            <RangePicker
              data-testid={`test-rangePicker`}
              disabled={disabled}
              locale={locale}
              value={field.value}
              onChange={(dates) => field.onChange(dates)}
              disabledDate={disabledDate}
              format="DD.MM.YYYY"
              style={{ width: "100%" }}
              status={fieldState.error ? "error" : ""}
              allowClear={false}
            />
            {fieldState.error && (
              <div className={styles.errorMessage}>
                {fieldState.error.message}
              </div>
            )}
          </>
        )}
      />
    </div>
  );
};
